export class ForgeProjectFeatureIteration {
    constructor(model) {
        var _a;
        this.id = model.id;
        this.name = model.name;
        this.startedFromMessageId = model.startedFromMessageId;
        this.isInProgress = (_a = model.isInProgress) !== null && _a !== void 0 ? _a : false;
        this.baseIterationId = model.baseIterationId;
        this.staticPreviewUrl = model.staticPreviewUrl;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : undefined;
    }
    toRemote() {
        var _a;
        return Object.assign(Object.assign({}, this), { createdAt: this.createdAt.toISOString(), updatedAt: (_a = this.updatedAt) === null || _a === void 0 ? void 0 : _a.toISOString() });
    }
}
